module.exports = __webpack_public_path__ + "static/media/mytrips_ic.537577c9.svg";